import React, { useContext, useState } from "react";
import { Box, Paper, Modal, Typography, Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { VALIDATOR_EMIAL } from "../../shared/util/validators";
import Input from "../../shared/components/Input";
import useForm from "../../shared/hooks/form-hooks";
import { useSnackbar } from "notistack";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const RecoveryModal = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formState, inputHandler] = useForm(
    {
      email: {
        value: "",
        isValid: false,
      },
    },
    false
  );
  const [isLoading, setIsLoading] = useState(false);

  const handleRecovery = (event) => {
    event.preventDefault();
    setIsLoading(true);
    axios
      .post(
        "/api/v1/auth/forgot-password",
        {
          email: formState.inputs.email.value,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        enqueueSnackbar("لینک تغییر رمز ارسال شد.", {
          variant: "success",
        });
        setIsLoading(false);
        props.handleClose();
      })
      .catch((e) => {
        const messages =
          e.response.data.data.length > 0
            ? e.response.data.data
            : e.response.data.message.message;

        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
        setIsLoading(false);
        props.handleClose();
      });
  };

  return (
    <div>
      <Modal open={props.open} onClose={props.handleClose}>
        <Box sx={style}>
          <Typography variant="h6" component="h2">
            بازیابی اکانت
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            لطفا ایمیل مربوط به این اکانت را وارد کنید.
          </Typography>

          {isLoading && (
            <div style={{ justifyContent: "center", display: "flex" }}>
              <CircularProgress color="inherit" />
            </div>
          )}
          {!isLoading && (
            <form onSubmit={handleRecovery}>
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid md={12} xs={12}>
                  <Input
                    id="email"
                    element="input"
                    label="ایمیل"
                    validators={[VALIDATOR_EMIAL()]}
                    errorText="ورودی نامعتبر"
                    onInput={inputHandler}
                  />
                </Grid>
                <Grid xs={6}>
                  <Button
                    type="submit"
                    fullWidth
                    color="success"
                    variant="contained"
                    disabled={!formState.isValid}
                  >
                    ارسال
                  </Button>
                </Grid>
                <Grid xs={6}>
                  <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    onClick={props.handleClose}
                  >
                    بازگشت
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default RecoveryModal;
